import { useParams, Outlet } from 'react-router-dom';
import { useProject } from '@/services/project.service';
import { useSample } from '@/services/sample.service';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { AlertCircleIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function SampleDetails() {
    const { projectId, sampleId } = useParams();
    const { data: project, error: projectError } = useProject(projectId);
    const { data: sample, error: sampleError } = useSample(projectId, sampleId);
    const { t } = useTranslation();

    if (projectError || sampleError) {
        return (
            <div className="max-w-6xl mx-auto px-8 py-10">
                <Alert variant="destructive">
                    <AlertCircleIcon className="h-4 w-4" />
                    <AlertTitle>{t('Error')}</AlertTitle>
                    <AlertDescription>
                        {projectError?.message || sampleError?.message}
                    </AlertDescription>
                </Alert>
            </div>
        );
    }

    if (!project || !sample)
        return (
            <p className="max-w-6xl mx-auto px-8 py-10 text-sm text-[#7a8077]">
                {t('Loading...')}
            </p>
        );

    return <Outlet />;
}
